export default __webpack_public_path__ + "static/media/back-woman.6d55ee93.jpg";